// Helpers pour l'affichage des noms d'intermittents.
// Convention : NOM en majuscules d'abord, Prénom en minuscules (1re lettre en majuscule) ensuite.
// Ex: {first_name: "jean-Pierre", last_name: "dupont"} -> "DUPONT Jean-Pierre"

function capitalizeName(raw) {
  if (!raw) return "";
  // Capitalise chaque partie séparée par espace ou tiret (préserve les composés).
  return raw
    .toLocaleLowerCase("fr-FR")
    .split(/([\s-])/)
    .map(part => {
      if (/^[\s-]$/.test(part) || !part) return part;
      return part.charAt(0).toLocaleUpperCase("fr-FR") + part.slice(1);
    })
    .join("");
}

export function formatIntermittentName(p) {
  if (!p) return "";
  const last = (p.last_name || "").toLocaleUpperCase("fr-FR");
  const first = capitalizeName(p.first_name || "");
  return [last, first].filter(Boolean).join(" ").trim();
}
